import ServerValidate from './servervalidation.directive';

export default angular.module('app.directives.module', [])
    .directive('serverValidate', ServerValidate)

    .name;


/** WEBPACK FOOTER **
 ** ./src/directives/index.js
 **/